import clsx from "clsx";
import Icon from "../Icon/Icon";

export default function ServiceCard({
  title,
  className,
}: {
  title?: string | null;
  className?: string;
}) {
  return (
    <div
      className={clsx([
        "relative h-full w-full lg:cursor-customCursor",
        className,
      ])}
    >
      {/* We need the arbitrary selector, because the parent container needs the group modifier to work */}
      <div className="group peer relative flex h-full flex-col justify-between bg-black px-5 py-6 lg:px-15 lg:py-10 lg:[&:hover>*]:text-black">
        {title && (
          <h4 className="grow-1 relative z-10 text-left text-heading-6 text-white transition-colors lg:text-heading-5">
            {title}
          </h4>
        )}

        <div className="flex h-10 w-10 items-center justify-center self-end justify-self-end rounded bg-blue lg:hidden ">
          <Icon type="plus" />
        </div>
      </div>
      <div className="pointer-events-none absolute bottom-0 left-0 hidden h-full w-full origin-bottom scale-y-0 bg-grey transition-transform lg:block lg:peer-hover:scale-y-100"></div>
    </div>
  );
}
